export const domain = 'Cache';

// action types
export const ADD_CACHE = `${domain}/ADD_CACHE`;
export const PURGE_CACHE = `${domain}/PURGE_CACHE`;
